import React from "react";

var feeSvg = function feeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.154 7.074c.324 1.2.327 2.468.003 3.677-1.015 3.777-4.907 6.018-8.694 5.006-3.787-1.012-6.034-4.894-5.02-8.671.951-3.54 4.43-5.73 7.979-5.16L7.242 6.32c-.424 1.578 1.12 2.971 2.646 2.387zm-4.981-.235L11.01 0a7.092 7.092 0 0 1 4.79 4.302z",
    fillRule: "evenodd"
  }));
};

feeSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var fee = {
  category: 'icon',
  colorable: true,
  name: 'fee',
  svg: feeSvg
};